import React, { ReactElement } from 'react'
import { CustomerModel } from '@/typings/models/Customer'
import { Avatar, Space } from 'antd'
import { useDispatch } from 'umi'
import ActionTag from '@/components/ActionTag'
import isEmpty from 'lodash/isEmpty'

export interface CustomerNameProps {
  customer: CustomerModel,
  drawer?: boolean,
  fallback?: ReactElement | string,
}

export function getCustomerText(customer: CustomerModel){
  return `${customer.firstname || ""} ${customer.lastname || ""}`
}

const CustomerName =
  ({
     customer,
     fallback = " - ",
     children,
     drawer = false
   }: React.PropsWithChildren<CustomerNameProps>) => {

    const dispatch = useDispatch()
    function toggleDrawer() {
      dispatch({
        type: "customers/toggleDrawer",
        payload: {
          customer
        }
      })
    }
    if (!customer && !children) {
      return <>{fallback}</>;
    }
    let name = `${customer.firstname || ""} ${customer.lastname || ""}`
    if (isEmpty(name.trim())) name = " - "
    const avatar = (
      <Avatar size={"small"}>
        {name.slice(0, 2)}
      </Avatar>
    );
    const content = children ? children : <Space size={3}>
      {avatar}
      <div>
        {name}
      </div>
    </Space>


    if (drawer) {
      return <ActionTag onClick={toggleDrawer} size="large">
        {content}
      </ActionTag>
    }
    return <div>
      {content}
    </div>
  };

export default CustomerName
